import React, { Component } from 'react';
import * as UserActions from "../actions/UserActions";
import {connect} from 'react-redux'
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";

class TeamInvitePage extends Component {

    render(){
        return (
            <div className="form-holder">
                <div className="card">
                    <div className="card-heading">
                        <h1 className="card-title">
                            Welcome!
                            <div className="pull-right">
                                <Link to="/new-team"><Button>create team</Button></Link> &nbsp;
                                {this.props.user && (
                                    <Link to=""><Button bsStyle="primary">go to app</Button></Link>
                                )}
                                {!this.props.user && (
                                    <Link to="/sign-in"><Button bsStyle="primary">log in</Button></Link>
                                )}
                            </div>
                        </h1>
                    </div>
                    <div className="card-body">
                        This is the greatest website you've ever seen. Trust me. It's great.
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    users: state.users,
    user: state.users.active
}), dispatch => ({
    setActiveUser: id => dispatch(UserActions.setActiveUser(id))
}))(TeamInvitePage);


// WEBPACK FOOTER //
// ./src/pages/PublicWebsitePage.js